import ExtendableError from './ExtendableError.js';
/** Thrown if field.checkValidity() fails */
export default class InvalidFormFieldError extends ExtendableError {
    constructor(formfield) {
        console.log('InvalidFormFieldError for field:', formfield.getName());
        let formFieldGroup = formfield.getFormFieldGroup();
        let fieldset = formFieldGroup?.getFieldset() || null;
        let msg = `Invalid value for field "${formfield.getLabel().getInnerHTML() || formfield.getName()}"`;
        if (formFieldGroup !== null) {
            msg += ` in form field group "${formFieldGroup.getName()}"`;
        }
        if (fieldset !== null) {
            msg += ` in fieldset "${fieldset.getLegend()?.getInnerHTML()}"`;
        }
        super(msg);
    }
}
